import { Injectable } from '@angular/core';
import { BRAND } from './brand';
import { Brand } from './brand.types';

@Injectable({ providedIn: 'root' })
export class BrandService {
  readonly config: Brand = BRAND;

  constructor() {
    if (typeof document !== 'undefined') {
      document.documentElement.dataset['flavor'] = BRAND.id;
      document.documentElement.classList.add(`flavor-${BRAND.id}`);
    }
  }

  get id(): string {
    return BRAND.id;
  }

  get productName(): string {
    return BRAND.productName;
  }

  get logo(): string {
    return BRAND.logo;
  }

  get logoMark(): string {
    return BRAND.logoMark;
  }

  get logoMarkSrcset(): string {
    if (BRAND.logoMark2x) {
      return `${BRAND.logoMark} 1x, ${BRAND.logoMark2x} 2x`;
    }
    return BRAND.logoMark;
  }

  get loginBackground(): boolean {
    return BRAND.loginBackground;
  }

  get showMascot(): boolean {
    return BRAND.showMascot;
  }

  get supportEmail(): string {
    return BRAND.supportEmail;
  }

  get privacyEmail(): string {
    return BRAND.privacyEmail;
  }

  get showCopyright(): boolean {
    return BRAND.showCopyright;
  }

  get showBilling(): boolean {
    return BRAND.showBilling;
  }

  get showSocialLogin(): boolean {
    return BRAND.showSocialLogin;
  }

  get copyrightHolder(): string {
    return BRAND.copyrightHolder;
  }

  storageKey(suffix: string): string {
    return `${BRAND.storagePrefix}.${suffix}`;
  }
}
